import { Box, Button } from '@mui/material';
import { ArrowLeftIcon } from '@tix-ticketing/ui-icons/outline';
import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { IconButton } from '../components/button/icon-button';

// Small buttons below md, medium from md up.
const buttonSizes = [
  { size: 'small', display: { xs: 'block', md: 'none' } },
  { size: 'medium', display: { xs: 'none', md: 'block' } },
] as const;

/**
 * The monochrome back button shared by `PageHeader` and `GoBackHeaderAction`:
 * icon-only, or labelled when `text` is given.
 */
export const BackButton = ({
  onClick,
  text,
  ariaLabel,
}: {
  onClick: () => void;
  text?: ReactNode;
  ariaLabel?: string;
}) => {
  const intl = useIntl();
  const label =
    ariaLabel ??
    intl.formatMessage({ id: 'common.back', defaultMessage: 'Back' });

  return (
    <>
      {buttonSizes.map(({ size, display }) => (
        <Box key={size} sx={{ display }}>
          {text ? (
            <Button
              variant="contained"
              color="monochrome"
              startIcon={<ArrowLeftIcon />}
              onClick={onClick}
              size={size}
            >
              {text}
            </Button>
          ) : (
            <IconButton
              variant="contained"
              color="monochrome"
              onClick={onClick}
              label={label}
              size={size}
            >
              <ArrowLeftIcon />
            </IconButton>
          )}
        </Box>
      ))}
    </>
  );
};
